var cov_265yqg3il5 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/SimpleTable.tsx",
      hash = "e2f9a0b64d285714ecb8d1011046f85107894ef4",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/SimpleTable.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 80
        }
      },
      "1": {
        start: {
          line: 15,
          column: 50
        },
        end: {
          line: 15,
          column: 80
        }
      },
      "2": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 16
        }
      },
      "3": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "4": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 60
        }
      },
      "5": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 59
        }
      },
      "6": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 55
        }
      },
      "7": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 59
        }
      },
      "8": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 52
        }
      },
      "9": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 56
        }
      },
      "10": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 54
        }
      },
      "11": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 26
        }
      },
      "12": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 22
        }
      },
      "13": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 22
        }
      },
      "14": {
        start: {
          line: 72,
          column: 19
        },
        end: {
          line: 72,
          column: 72
        }
      },
      "15": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 76
        }
      },
      "16": {
        start: {
          line: 74,
          column: 29
        },
        end: {
          line: 74,
          column: 76
        }
      },
      "17": {
        start: {
          line: 75,
          column: 32
        },
        end: {
          line: 75,
          column: 97
        }
      },
      "18": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 79,
          column: 5
        }
      },
      "19": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 58
        }
      },
      "20": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 83
        }
      },
      "21": {
        start: {
          line: 83,
          column: 19
        },
        end: {
          line: 83,
          column: 83
        }
      },
      "22": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 62
        }
      },
      "23": {
        start: {
          line: 84,
          column: 35
        },
        end: {
          line: 84,
          column: 62
        }
      },
      "24": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 18
        }
      },
      "25": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 93,
          column: 5
        }
      },
      "26": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 80
        }
      },
      "27": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 95
        }
      },
      "28": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 64
        }
      },
      "29": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 56
        }
      },
      "30": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 26
        }
      },
      "31": {
        start: {
          line: 102,
          column: 20
        },
        end: {
          line: 102,
          column: 26
        }
      },
      "32": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "33": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 41
        }
      },
      "34": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 12
        }
      },
      "35": {
        start: {
          line: 107,
          column: 23
        },
        end: {
          line: 107,
          column: 70
        }
      },
      "36": {
        start: {
          line: 108,
          column: 22
        },
        end: {
          line: 108,
          column: 67
        }
      },
      "37": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 72
        }
      },
      "38": {
        start: {
          line: 109,
          column: 44
        },
        end: {
          line: 109,
          column: 72
        }
      },
      "39": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 75
        }
      },
      "40": {
        start: {
          line: 110,
          column: 46
        },
        end: {
          line: 110,
          column: 75
        }
      },
      "41": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 27
        }
      },
      "42": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 116,
          column: 6
        }
      },
      "43": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 28
        }
      },
      "44": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 42
        }
      },
      "45": {
        start: {
          line: 127,
          column: 19
        },
        end: {
          line: 127,
          column: 42
        }
      },
      "46": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 75
        }
      },
      "47": {
        start: {
          line: 132,
          column: 24
        },
        end: {
          line: 132,
          column: 34
        }
      },
      "48": {
        start: {
          line: 133,
          column: 21
        },
        end: {
          line: 133,
          column: 23
        }
      },
      "49": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "50": {
        start: {
          line: 135,
          column: 24
        },
        end: {
          line: 135,
          column: 54
        }
      },
      "51": {
        start: {
          line: 136,
          column: 22
        },
        end: {
          line: 136,
          column: 72
        }
      },
      "52": {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 141,
          column: 7
        }
      },
      "53": {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 138,
          column: 99
        }
      },
      "54": {
        start: {
          line: 138,
          column: 45
        },
        end: {
          line: 138,
          column: 66
        }
      },
      "55": {
        start: {
          line: 138,
          column: 82
        },
        end: {
          line: 138,
          column: 98
        }
      },
      "56": {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 140,
          column: 28
        }
      },
      "57": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 143,
          column: 46
        }
      },
      "58": {
        start: {
          line: 147,
          column: 27
        },
        end: {
          line: 147,
          column: 40
        }
      },
      "59": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 42
        }
      },
      "60": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 40
        }
      },
      "61": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 42
        }
      },
      "62": {
        start: {
          line: 154,
          column: 82
        },
        end: {
          line: 154,
          column: 92
        }
      },
      "63": {
        start: {
          line: 155,
          column: 37
        },
        end: {
          line: 155,
          column: 47
        }
      },
      "64": {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 161,
          column: 14
        }
      },
      "65": {
        start: {
          line: 163,
          column: 18
        },
        end: {
          line: 163,
          column: 35
        }
      },
      "66": {
        start: {
          line: 164,
          column: 45
        },
        end: {
          line: 164,
          column: 47
        }
      },
      "67": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 165,
          column: 72
        }
      },
      "68": {
        start: {
          line: 165,
          column: 16
        },
        end: {
          line: 165,
          column: 72
        }
      },
      "69": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 175,
          column: 12
        }
      },
      "70": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 184,
          column: 5
        }
      },
      "71": {
        start: {
          line: 178,
          column: 26
        },
        end: {
          line: 178,
          column: 59
        }
      },
      "72": {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 183,
          column: 7
        }
      },
      "73": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 185,
          column: 17
        }
      },
      "74": {
        start: {
          line: 189,
          column: 73
        },
        end: {
          line: 189,
          column: 83
        }
      },
      "75": {
        start: {
          line: 190,
          column: 48
        },
        end: {
          line: 190,
          column: 58
        }
      },
      "76": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 191,
          column: 43
        }
      },
      "77": {
        start: {
          line: 191,
          column: 32
        },
        end: {
          line: 191,
          column: 43
        }
      },
      "78": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 192,
          column: 49
        }
      },
      "79": {
        start: {
          line: 192,
          column: 38
        },
        end: {
          line: 192,
          column: 49
        }
      },
      "80": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 198,
          column: 14
        }
      },
      "81": {
        start: {
          line: 200,
          column: 43
        },
        end: {
          line: 200,
          column: 45
        }
      },
      "82": {
        start: {
          line: 201,
          column: 4
        },
        end: {
          line: 201,
          column: 58
        }
      },
      "83": {
        start: {
          line: 204,
          column: 6
        },
        end: {
          line: 212,
          column: 12
        }
      },
      "84": {
        start: {
          line: 214,
          column: 4
        },
        end: {
          line: 214,
          column: 17
        }
      },
      "85": {
        start: {
          line: 218,
          column: 76
        },
        end: {
          line: 218,
          column: 86
        }
      },
      "86": {
        start: {
          line: 219,
          column: 33
        },
        end: {
          line: 219,
          column: 43
        }
      },
      "87": {
        start: {
          line: 220,
          column: 24
        },
        end: {
          line: 220,
          column: 53
        }
      },
      "88": {
        start: {
          line: 220,
          column: 42
        },
        end: {
          line: 220,
          column: 52
        }
      },
      "89": {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 241,
          column: 5
        }
      },
      "90": {
        start: {
          line: 245,
          column: 63
        },
        end: {
          line: 245,
          column: 73
        }
      },
      "91": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 251,
          column: 7
        }
      },
      "92": {
        start: {
          line: 247,
          column: 6
        },
        end: {
          line: 251,
          column: 7
        }
      },
      "93": {
        start: {
          line: 252,
          column: 4
        },
        end: {
          line: 252,
          column: 102
        }
      }
    },
    fnMap: {
      "0": {
        name: "setScrollLeft",
        decl: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 22
          }
        },
        loc: {
          start: {
            line: 14,
            column: 64
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 56
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 22
          },
          end: {
            line: 68,
            column: 3
          }
        },
        line: 66
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        },
        loc: {
          start: {
            line: 70,
            column: 67
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 70
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        },
        loc: {
          start: {
            line: 82,
            column: 25
          },
          end: {
            line: 85,
            column: 3
          }
        },
        line: 82
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        loc: {
          start: {
            line: 87,
            column: 69
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 87
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 96,
            column: 3
          }
        },
        loc: {
          start: {
            line: 96,
            column: 18
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 96
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 16
          },
          end: {
            line: 117,
            column: 3
          }
        },
        line: 101
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 114,
            column: 15
          },
          end: {
            line: 114,
            column: 16
          }
        },
        loc: {
          start: {
            line: 114,
            column: 21
          },
          end: {
            line: 116,
            column: 5
          }
        },
        line: 114
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 119,
            column: 2
          },
          end: {
            line: 119,
            column: 3
          }
        },
        loc: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 126
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 131,
            column: 2
          },
          end: {
            line: 131,
            column: 3
          }
        },
        loc: {
          start: {
            line: 131,
            column: 56
          },
          end: {
            line: 144,
            column: 3
          }
        },
        line: 131
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 138,
            column: 40
          },
          end: {
            line: 138,
            column: 41
          }
        },
        loc: {
          start: {
            line: 138,
            column: 45
          },
          end: {
            line: 138,
            column: 66
          }
        },
        line: 138
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 138,
            column: 77
          },
          end: {
            line: 138,
            column: 78
          }
        },
        loc: {
          start: {
            line: 138,
            column: 82
          },
          end: {
            line: 138,
            column: 98
          }
        },
        line: 138
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 146,
            column: 2
          },
          end: {
            line: 146,
            column: 3
          }
        },
        loc: {
          start: {
            line: 146,
            column: 66
          },
          end: {
            line: 151,
            column: 3
          }
        },
        line: 146
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 153,
            column: 2
          },
          end: {
            line: 153,
            column: 3
          }
        },
        loc: {
          start: {
            line: 153,
            column: 17
          },
          end: {
            line: 186,
            column: 3
          }
        },
        line: 153
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 188,
            column: 2
          },
          end: {
            line: 188,
            column: 3
          }
        },
        loc: {
          start: {
            line: 188,
            column: 17
          },
          end: {
            line: 215,
            column: 3
          }
        },
        line: 188
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 217,
            column: 2
          },
          end: {
            line: 217,
            column: 3
          }
        },
        loc: {
          start: {
            line: 217,
            column: 15
          },
          end: {
            line: 242,
            column: 3
          }
        },
        line: 217
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 220,
            column: 37
          },
          end: {
            line: 220,
            column: 38
          }
        },
        loc: {
          start: {
            line: 220,
            column: 42
          },
          end: {
            line: 220,
            column: 52
          }
        },
        line: 220
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 244,
            column: 2
          },
          end: {
            line: 244,
            column: 3
          }
        },
        loc: {
          start: {
            line: 244,
            column: 11
          },
          end: {
            line: 253,
            column: 3
          }
        },
        line: 244
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 80
          }
        }, {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 80
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 15,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 15,
            column: 12
          }
        }, {
          start: {
            line: 15,
            column: 16
          },
          end: {
            line: 15,
            column: 48
          }
        }],
        line: 15
      },
      "2": {
        loc: {
          start: {
            line: 72,
            column: 19
          },
          end: {
            line: 72,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 19
          },
          end: {
            line: 72,
            column: 46
          }
        }, {
          start: {
            line: 72,
            column: 50
          },
          end: {
            line: 72,
            column: 72
          }
        }],
        line: 72
      },
      "3": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 76
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 76
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 76
          }
        }],
        line: 74
      },
      "4": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 14
          }
        }, {
          start: {
            line: 74,
            column: 18
          },
          end: {
            line: 74,
            column: 27
          }
        }],
        line: 74
      },
      "5": {
        loc: {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 59
          }
        }, {
          start: {
            line: 75,
            column: 63
          },
          end: {
            line: 75,
            column: 97
          }
        }],
        line: 75
      },
      "6": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        }],
        line: 76
      },
      "7": {
        loc: {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 14
          }
        }, {
          start: {
            line: 76,
            column: 18
          },
          end: {
            line: 76,
            column: 37
          }
        }, {
          start: {
            line: 76,
            column: 41
          },
          end: {
            line: 76,
            column: 95
          }
        }],
        line: 76
      },
      "8": {
        loc: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 83
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 83
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 83
          }
        }],
        line: 83
      },
      "9": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 62
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 62
          }
        }],
        line: 84
      },
      "10": {
        loc: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        }, {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        }],
        line: 90
      },
      "11": {
        loc: {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 90,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 90,
            column: 22
          }
        }, {
          start: {
            line: 90,
            column: 26
          },
          end: {
            line: 90,
            column: 28
          }
        }],
        line: 90
      },
      "12": {
        loc: {
          start: {
            line: 97,
            column: 24
          },
          end: {
            line: 97,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 97,
            column: 24
          },
          end: {
            line: 97,
            column: 43
          }
        }, {
          start: {
            line: 97,
            column: 47
          },
          end: {
            line: 97,
            column: 64
          }
        }],
        line: 97
      },
      "13": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 26
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 26
          }
        }],
        line: 102
      },
      "14": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }],
        line: 103
      },
      "15": {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 109,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 109,
            column: 72
          }
        }, {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 109,
            column: 72
          }
        }],
        line: 109
      },
      "16": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 110,
            column: 75
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 110,
            column: 75
          }
        }, {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 110,
            column: 75
          }
        }],
        line: 110
      },
      "17": {
        loc: {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 127,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 127,
            column: 42
          }
        }, {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 127,
            column: 42
          }
        }],
        line: 127
      },
      "18": {
        loc: {
          start: {
            line: 136,
            column: 31
          },
          end: {
            line: 136,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 31
          },
          end: {
            line: 136,
            column: 61
          }
        }, {
          start: {
            line: 136,
            column: 65
          },
          end: {
            line: 136,
            column: 67
          }
        }],
        line: 136
      },
      "19": {
        loc: {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        }, {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        }],
        line: 137
      },
      "20": {
        loc: {
          start: {
            line: 157,
            column: 53
          },
          end: {
            line: 157,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 53
          },
          end: {
            line: 157,
            column: 61
          }
        }, {
          start: {
            line: 157,
            column: 65
          },
          end: {
            line: 157,
            column: 81
          }
        }],
        line: 157
      },
      "21": {
        loc: {
          start: {
            line: 159,
            column: 28
          },
          end: {
            line: 159,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 28
          },
          end: {
            line: 159,
            column: 36
          }
        }, {
          start: {
            line: 159,
            column: 40
          },
          end: {
            line: 159,
            column: 57
          }
        }],
        line: 159
      },
      "22": {
        loc: {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 72
          }
        }, {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 165,
            column: 72
          }
        }],
        line: 165
      },
      "23": {
        loc: {
          start: {
            line: 165,
            column: 40
          },
          end: {
            line: 165,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 165,
            column: 53
          },
          end: {
            line: 165,
            column: 61
          }
        }, {
          start: {
            line: 165,
            column: 64
          },
          end: {
            line: 165,
            column: 72
          }
        }],
        line: 165
      },
      "24": {
        loc: {
          start: {
            line: 171,
            column: 53
          },
          end: {
            line: 171,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 53
          },
          end: {
            line: 171,
            column: 58
          }
        }, {
          start: {
            line: 171,
            column: 62
          },
          end: {
            line: 171,
            column: 74
          }
        }],
        line: 171
      },
      "25": {
        loc: {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        }, {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        }],
        line: 177
      },
      "26": {
        loc: {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 43
          }
        }, {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 43
          }
        }],
        line: 191
      },
      "27": {
        loc: {
          start: {
            line: 191,
            column: 10
          },
          end: {
            line: 191,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 191,
            column: 10
          },
          end: {
            line: 191,
            column: 14
          }
        }, {
          start: {
            line: 191,
            column: 18
          },
          end: {
            line: 191,
            column: 29
          }
        }],
        line: 191
      },
      "28": {
        loc: {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 49
          }
        }, {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 49
          }
        }],
        line: 192
      },
      "29": {
        loc: {
          start: {
            line: 192,
            column: 10
          },
          end: {
            line: 192,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 192,
            column: 10
          },
          end: {
            line: 192,
            column: 17
          }
        }, {
          start: {
            line: 192,
            column: 21
          },
          end: {
            line: 192,
            column: 35
          }
        }],
        line: 192
      },
      "30": {
        loc: {
          start: {
            line: 195,
            column: 53
          },
          end: {
            line: 195,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 195,
            column: 53
          },
          end: {
            line: 195,
            column: 61
          }
        }, {
          start: {
            line: 195,
            column: 65
          },
          end: {
            line: 195,
            column: 81
          }
        }],
        line: 195
      },
      "31": {
        loc: {
          start: {
            line: 196,
            column: 28
          },
          end: {
            line: 196,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 196,
            column: 28
          },
          end: {
            line: 196,
            column: 36
          }
        }, {
          start: {
            line: 196,
            column: 40
          },
          end: {
            line: 196,
            column: 57
          }
        }],
        line: 196
      },
      "32": {
        loc: {
          start: {
            line: 201,
            column: 26
          },
          end: {
            line: 201,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 201,
            column: 39
          },
          end: {
            line: 201,
            column: 47
          }
        }, {
          start: {
            line: 201,
            column: 50
          },
          end: {
            line: 201,
            column: 58
          }
        }],
        line: 201
      },
      "33": {
        loc: {
          start: {
            line: 207,
            column: 38
          },
          end: {
            line: 207,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 207,
            column: 38
          },
          end: {
            line: 207,
            column: 47
          }
        }, {
          start: {
            line: 207,
            column: 51
          },
          end: {
            line: 207,
            column: 66
          }
        }],
        line: 207
      },
      "34": {
        loc: {
          start: {
            line: 225,
            column: 32
          },
          end: {
            line: 225,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 32
          },
          end: {
            line: 225,
            column: 41
          }
        }, {
          start: {
            line: 225,
            column: 45
          },
          end: {
            line: 225,
            column: 56
          }
        }, {
          start: {
            line: 225,
            column: 60
          },
          end: {
            line: 225,
            column: 66
          }
        }],
        line: 225
      },
      "35": {
        loc: {
          start: {
            line: 225,
            column: 68
          },
          end: {
            line: 225,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 68
          },
          end: {
            line: 225,
            column: 76
          }
        }, {
          start: {
            line: 225,
            column: 80
          },
          end: {
            line: 225,
            column: 96
          }
        }],
        line: 225
      },
      "36": {
        loc: {
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 251,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 251,
            column: 7
          }
        }, {
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 251,
            column: 7
          }
        }],
        line: 246
      },
      "37": {
        loc: {
          start: {
            line: 246,
            column: 8
          },
          end: {
            line: 246,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 246,
            column: 8
          },
          end: {
            line: 246,
            column: 16
          }
        }, {
          start: {
            line: 246,
            column: 20
          },
          end: {
            line: 246,
            column: 40
          }
        }],
        line: 246
      },
      "38": {
        loc: {
          start: {
            line: 248,
            column: 55
          },
          end: {
            line: 248,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 248,
            column: 55
          },
          end: {
            line: 248,
            column: 63
          }
        }, {
          start: {
            line: 248,
            column: 67
          },
          end: {
            line: 248,
            column: 83
          }
        }],
        line: 248
      },
      "39": {
        loc: {
          start: {
            line: 252,
            column: 12
          },
          end: {
            line: 252,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 252,
            column: 25
          },
          end: {
            line: 252,
            column: 29
          }
        }, {
          start: {
            line: 252,
            column: 32
          },
          end: {
            line: 252,
            column: 51
          }
        }],
        line: 252
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/SimpleTable.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import { tableClass } from './styles';
import { range, split } from '../utils/numbers';
import Colgroup from './Colgroup';
import Tbody from './Tbody';
import Thead from './Thead';
import Tfoot from './Tfoot';
import { compareColumns } from '../utils/shallowEqual';
import Sticky from '../Sticky';
import { addResizeObserver } from '../utils/dom/element';

function setScrollLeft(target, scrollLeft) {
  cov_265yqg3il5.f[0]++;
  cov_265yqg3il5.s[0]++;

  if ((cov_265yqg3il5.b[1][0]++, target) && (cov_265yqg3il5.b[1][1]++, target.scrollLeft !== scrollLeft)) {
    cov_265yqg3il5.b[0][0]++;
    cov_265yqg3il5.s[1]++;
    target.scrollLeft = scrollLeft;
  } else {
    cov_265yqg3il5.b[0][1]++;
  }
}

var SimpleTable =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SimpleTable, _PureComponent);

  var _super = _createSuper2(SimpleTable);

  function SimpleTable(props) {
    var _this;

    _classCallCheck(this, SimpleTable);

    cov_265yqg3il5.f[1]++;
    cov_265yqg3il5.s[2]++;
    _this = _super.call(this, props);
    _this.bindHeader = void 0;
    _this.bindBody = void 0;
    _this.bindFooter = void 0;
    _this.removeReiszeObserver = void 0;
    _this.body = void 0;
    _this.header = void 0;
    _this.footer = void 0;
    _this.lastColGroup = void 0;
    _this.cyclicCounter = void 0;
    cov_265yqg3il5.s[3]++;
    _this.state = {
      colgroup: undefined,
      overHeight: false,
      overWidth: false,
      resize: false
    };
    cov_265yqg3il5.s[4]++;
    _this.handleSortChange = _this.handleSortChange.bind(_assertThisInitialized(_this));
    cov_265yqg3il5.s[5]++;
    _this.bindHeader = _this.bindElement.bind(_assertThisInitialized(_this), 'header');
    cov_265yqg3il5.s[6]++;
    _this.bindBody = _this.bindElement.bind(_assertThisInitialized(_this), 'body');
    cov_265yqg3il5.s[7]++;
    _this.bindFooter = _this.bindElement.bind(_assertThisInitialized(_this), 'footer');
    cov_265yqg3il5.s[8]++;
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    cov_265yqg3il5.s[9]++;
    _this.handleColgroup = _this.handleColgroup.bind(_assertThisInitialized(_this));
    cov_265yqg3il5.s[10]++;
    _this.resetColGroup = _this.resetColGroup.bind(_assertThisInitialized(_this)); // 循环计数器。某些情况[*]下滚动条的出现会导致死循环问题，这里做一个计数器，超过一定次数就不再重置，认定最大 10 次为死循环
    // [*] 横向滚动条的出现可能导致竖向滚动条从有到无。此时需要重新计算表头的宽度，否则会出现表头与表格内容不对齐的问题。纵向滚动条消失后，可能导致横向滚动条宽度足够，纵向滚动条再次出现，又导致横向滚动条消失，如此循环。

    cov_265yqg3il5.s[11]++;
    _this.cyclicCounter = 0;
    return _this;
  }

  _createClass(SimpleTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_265yqg3il5.f[2]++;
      cov_265yqg3il5.s[12]++;
      this.scrollCheck();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_265yqg3il5.f[3]++;
      cov_265yqg3il5.s[13]++;
      this.scrollCheck();
      var resize = (cov_265yqg3il5.s[14]++, (cov_265yqg3il5.b[2][0]++, prevProps.data.length === 0) && (cov_265yqg3il5.b[2][1]++, this.props.data.length)); // when resize

      cov_265yqg3il5.s[15]++;

      if ((cov_265yqg3il5.b[4][0]++, resize) && (cov_265yqg3il5.b[4][1]++, this.body)) {
        cov_265yqg3il5.b[3][0]++;
        cov_265yqg3il5.s[16]++;
        this.handleScroll({
          currentTarget: this.body
        });
      } else {
        cov_265yqg3il5.b[3][1]++;
      }

      var shouldResetColgroup = (cov_265yqg3il5.s[17]++, (cov_265yqg3il5.b[5][0]++, this.props.dataChangeResize) && (cov_265yqg3il5.b[5][1]++, this.props.data !== prevProps.data));
      cov_265yqg3il5.s[18]++;

      if ((cov_265yqg3il5.b[7][0]++, resize) || (cov_265yqg3il5.b[7][1]++, shouldResetColgroup) || (cov_265yqg3il5.b[7][2]++, !compareColumns(prevProps.columns, this.props.columns))) {
        cov_265yqg3il5.b[6][0]++;
        cov_265yqg3il5.s[19]++;
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          colgroup: undefined,
          resize: true
        });
      } else {
        cov_265yqg3il5.b[6][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_265yqg3il5.f[4]++;
      cov_265yqg3il5.s[20]++;

      if (this.body) {
        cov_265yqg3il5.b[8][0]++;
        cov_265yqg3il5.s[21]++;
        this.body.removeEventListener('wheel', this.handleScroll);
      } else {
        cov_265yqg3il5.b[8][1]++;
      }

      cov_265yqg3il5.s[22]++;

      if (this.removeReiszeObserver) {
        cov_265yqg3il5.b[9][0]++;
        cov_265yqg3il5.s[23]++;
        this.removeReiszeObserver();
      } else {
        cov_265yqg3il5.b[9][1]++;
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(key, el) {
      cov_265yqg3il5.f[5]++;
      cov_265yqg3il5.s[24]++;
      this[key] = el; // this.body will be undefined on componentDidMount when columns length is 0

      cov_265yqg3il5.s[25]++;

      if ((cov_265yqg3il5.b[11][0]++, key === 'body') && (cov_265yqg3il5.b[11][1]++, el)) {
        cov_265yqg3il5.b[10][0]++;
        cov_265yqg3il5.s[26]++;
        el.addEventListener('wheel', this.handleScroll, {
          passive: false
        });
        cov_265yqg3il5.s[27]++;
        this.removeReiszeObserver = addResizeObserver(el, this.resetColGroup, {
          direction: 'x'
        });
      } else {
        cov_265yqg3il5.b[10][1]++;
      }
    }
  }, {
    key: "resetColGroup",
    value: function resetColGroup() {
      cov_265yqg3il5.f[6]++;
      cov_265yqg3il5.s[28]++;
      this.lastColGroup = (cov_265yqg3il5.b[12][0]++, this.state.colgroup) || (cov_265yqg3il5.b[12][1]++, this.lastColGroup);
      cov_265yqg3il5.s[29]++;
      this.setState({
        colgroup: undefined,
        resize: true
      });
    }
  }, {
    key: "scrollCheck",
    value: function scrollCheck() {
      var _this2 = this;

      cov_265yqg3il5.f[7]++;
      cov_265yqg3il5.s[30]++;

      if (!this.body) {
        cov_265yqg3il5.b[13][0]++;
        cov_265yqg3il5.s[31]++;
        return;
      } else {
        cov_265yqg3il5.b[13][1]++;
      }

      cov_265yqg3il5.s[32]++;

      if (this.cyclicCounter > 10) {
        cov_265yqg3il5.b[14][0]++;
        cov_265yqg3il5.s[33]++;
        this.setState({
          overHeight: true
        });
        cov_265yqg3il5.s[34]++;
        return;
      } else {
        cov_265yqg3il5.b[14][1]++;
      }

      var overHeight = (cov_265yqg3il5.s[35]++, this.body.scrollHeight > this.body.clientHeight);
      var overWidth = (cov_265yqg3il5.s[36]++, this.body.scrollWidth > this.body.clientWidth);
      cov_265yqg3il5.s[37]++;

      if (overWidth !== this.state.overWidth) {
        cov_265yqg3il5.b[15][0]++;
        cov_265yqg3il5.s[38]++;
        this.setState({
          overWidth: overWidth
        });
      } else {
        cov_265yqg3il5.b[15][1]++;
      }

      cov_265yqg3il5.s[39]++;

      if (overHeight !== this.state.overHeight) {
        cov_265yqg3il5.b[16][0]++;
        cov_265yqg3il5.s[40]++;
        this.setState({
          overHeight: overHeight
        });
      } else {
        cov_265yqg3il5.b[16][1]++;
      }

      cov_265yqg3il5.s[41]++;
      this.cyclicCounter += 1;
      cov_265yqg3il5.s[42]++;
      setTimeout(function () {
        cov_265yqg3il5.f[8]++;
        cov_265yqg3il5.s[43]++;
        _this2.cyclicCounter = 0;
      });
    }
  }, {
    key: "handleSortChange",
    value: function handleSortChange(finalOrder, sorter, index, cancelOrder, // 是否是自动触发
    manual) {
      cov_265yqg3il5.f[9]++;
      cov_265yqg3il5.s[44]++;

      if (this.body) {
        cov_265yqg3il5.b[17][0]++;
        cov_265yqg3il5.s[45]++;
        this.body.scrollTop = 0;
      } else {
        cov_265yqg3il5.b[17][1]++;
      }

      cov_265yqg3il5.s[46]++;
      this.props.onSortChange(finalOrder, sorter, index, cancelOrder, manual);
    }
  }, {
    key: "handleColgroup",
    value: function handleColgroup(tds) {
      cov_265yqg3il5.f[10]++;

      var _ref = (cov_265yqg3il5.s[47]++, this.props),
          columns = _ref.columns;

      var colgroup = (cov_265yqg3il5.s[48]++, []);
      cov_265yqg3il5.s[49]++;

      var _loop = function _loop(i, count) {
        var _ref2 = (cov_265yqg3il5.s[50]++, tds[i].getBoundingClientRect()),
            width = _ref2.width;

        var colSpan = (cov_265yqg3il5.s[51]++, parseInt((cov_265yqg3il5.b[18][0]++, tds[i].getAttribute('colspan')) || (cov_265yqg3il5.b[18][1]++, ''), 10));
        cov_265yqg3il5.s[52]++;

        if (colSpan > 1) {
          cov_265yqg3il5.b[19][0]++;
          cov_265yqg3il5.s[53]++;
          split(width, range(colSpan).map(function (j) {
            cov_265yqg3il5.f[11]++;
            cov_265yqg3il5.s[54]++;
            return columns[i + j].width;
          })).forEach(function (w) {
            cov_265yqg3il5.f[12]++;
            cov_265yqg3il5.s[55]++;
            return colgroup.push(w);
          });
        } else {
          cov_265yqg3il5.b[19][1]++;
          cov_265yqg3il5.s[56]++;
          colgroup.push(width);
        }
      };

      for (var i = 0, count = tds.length; i < count; i++) {
        _loop(i, count);
      }

      cov_265yqg3il5.s[57]++;
      this.setState({
        colgroup: colgroup,
        resize: false
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(_ref3) {
      var currentTarget = _ref3.currentTarget;
      cov_265yqg3il5.f[13]++;

      var _ref4 = (cov_265yqg3il5.s[58]++, currentTarget),
          scrollLeft = _ref4.scrollLeft;

      cov_265yqg3il5.s[59]++;
      setScrollLeft(this.header, scrollLeft);
      cov_265yqg3il5.s[60]++;
      setScrollLeft(this.body, scrollLeft);
      cov_265yqg3il5.s[61]++;
      setScrollLeft(this.footer, scrollLeft);
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      cov_265yqg3il5.f[14]++;

      var _ref5 = (cov_265yqg3il5.s[62]++, this.props),
          columns = _ref5.columns,
          width = _ref5.width,
          data = _ref5.data,
          onResize = _ref5.onResize,
          columnResizable = _ref5.columnResizable,
          sticky = _ref5.sticky,
          bordered = _ref5.bordered;

      var _ref6 = (cov_265yqg3il5.s[63]++, this.state),
          colgroup = _ref6.colgroup,
          overHeight = _ref6.overHeight;

      var inner = (cov_265yqg3il5.s[64]++,
      /*#__PURE__*/
      React.createElement("table", {
        style: {
          width: width
        },
        className: tableClass((cov_265yqg3il5.b[20][0]++, bordered) && (cov_265yqg3il5.b[20][1]++, 'table-bordered')),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157,
          columnNumber: 7
        }
      },
      /*#__PURE__*/
      React.createElement(Colgroup, {
        colgroup: (cov_265yqg3il5.b[21][0]++, colgroup) || (cov_265yqg3il5.b[21][1]++, this.lastColGroup),
        columns: columns,
        resizable: columnResizable,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 159,
          columnNumber: 9
        }
      }),
      /*#__PURE__*/
      React.createElement(Thead, Object.assign({}, this.props, {
        colgroup: colgroup,
        onSortChange: this.handleSortChange,
        onColChange: onResize,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160,
          columnNumber: 9
        }
      }))));
      var empty = (cov_265yqg3il5.s[65]++, data.length === 0);
      var headerStyle = (cov_265yqg3il5.s[66]++, {});
      cov_265yqg3il5.s[67]++;

      if (!empty) {
        cov_265yqg3il5.b[22][0]++;
        cov_265yqg3il5.s[68]++;
        headerStyle.overflowY = overHeight ? (cov_265yqg3il5.b[23][0]++, 'scroll') : (cov_265yqg3il5.b[23][1]++, 'hidden');
      } else {
        cov_265yqg3il5.b[22][1]++;
      }

      var header = (cov_265yqg3il5.s[69]++,
      /*#__PURE__*/
      React.createElement("div", {
        key: "head",
        style: headerStyle,
        className: tableClass('head', 'simple-head', (cov_265yqg3il5.b[24][0]++, empty) && (cov_265yqg3il5.b[24][1]++, 'empty-head')),
        ref: this.bindHeader,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 168,
          columnNumber: 7
        }
      }, inner));
      cov_265yqg3il5.s[70]++;

      if (sticky) {
        cov_265yqg3il5.b[25][0]++;
        var stickyProps = (cov_265yqg3il5.s[71]++, Object.assign({
          top: 0
        }, sticky));
        cov_265yqg3il5.s[72]++;
        return (
          /*#__PURE__*/
          React.createElement(Sticky, Object.assign({}, stickyProps, {
            key: "head",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 180,
              columnNumber: 9
            }
          }), header)
        );
      } else {
        cov_265yqg3il5.b[25][1]++;
      }

      cov_265yqg3il5.s[73]++;
      return header;
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      cov_265yqg3il5.f[15]++;

      var _ref7 = (cov_265yqg3il5.s[74]++, this.props),
          columns = _ref7.columns,
          width = _ref7.width,
          data = _ref7.data,
          columnResizable = _ref7.columnResizable,
          bordered = _ref7.bordered,
          summary = _ref7.summary;

      var _ref8 = (cov_265yqg3il5.s[75]++, this.state),
          colgroup = _ref8.colgroup,
          overHeight = _ref8.overHeight,
          overWidth = _ref8.overWidth;

      cov_265yqg3il5.s[76]++;

      if (!((cov_265yqg3il5.b[27][0]++, data) && (cov_265yqg3il5.b[27][1]++, data.length))) {
        cov_265yqg3il5.b[26][0]++;
        cov_265yqg3il5.s[77]++;
        return null;
      } else {
        cov_265yqg3il5.b[26][1]++;
      }

      cov_265yqg3il5.s[78]++;

      if (!((cov_265yqg3il5.b[29][0]++, summary) && (cov_265yqg3il5.b[29][1]++, summary.length))) {
        cov_265yqg3il5.b[28][0]++;
        cov_265yqg3il5.s[79]++;
        return null;
      } else {
        cov_265yqg3il5.b[28][1]++;
      }

      var inner = (cov_265yqg3il5.s[80]++,
      /*#__PURE__*/
      React.createElement("table", {
        style: {
          width: width
        },
        className: tableClass((cov_265yqg3il5.b[30][0]++, bordered) && (cov_265yqg3il5.b[30][1]++, 'table-bordered')),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 195,
          columnNumber: 7
        }
      },
      /*#__PURE__*/
      React.createElement(Colgroup, {
        colgroup: (cov_265yqg3il5.b[31][0]++, colgroup) || (cov_265yqg3il5.b[31][1]++, this.lastColGroup),
        columns: columns,
        resizable: columnResizable,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 196,
          columnNumber: 9
        }
      }),
      /*#__PURE__*/
      React.createElement(Tfoot, Object.assign({}, this.props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 197,
          columnNumber: 9
        }
      }))));
      var footStyle = (cov_265yqg3il5.s[81]++, {});
      cov_265yqg3il5.s[82]++;
      footStyle.overflowY = overHeight ? (cov_265yqg3il5.b[32][0]++, 'scroll') : (cov_265yqg3il5.b[32][1]++, 'hidden');
      var footer = (cov_265yqg3il5.s[83]++,
      /*#__PURE__*/
      React.createElement("div", {
        key: "foot",
        style: footStyle,
        className: tableClass('foot', (cov_265yqg3il5.b[33][0]++, overWidth) && (cov_265yqg3il5.b[33][1]++, 'foot-scroll-x'), 'simple-foot'),
        ref: this.bindFooter,
        onScroll: this.handleScroll,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 204,
          columnNumber: 7
        }
      }, inner));
      cov_265yqg3il5.s[84]++;
      return footer;
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      cov_265yqg3il5.f[16]++;

      var _ref9 = (cov_265yqg3il5.s[85]++, this.props),
          columns = _ref9.columns,
          width = _ref9.width,
          fixed = _ref9.fixed,
          columnResizable = _ref9.columnResizable,
          bordered = _ref9.bordered,
          others = _objectWithoutProperties(_ref9, ["columns", "width", "fixed", "columnResizable", "bordered"]);

      var _ref10 = (cov_265yqg3il5.s[86]++, this.state),
          colgroup = _ref10.colgroup,
          resize = _ref10.resize;

      var minWidthSup = (cov_265yqg3il5.s[87]++, columns.find(function (d) {
        cov_265yqg3il5.f[17]++;
        cov_265yqg3il5.s[88]++;
        return d.minWidth;
      }));
      cov_265yqg3il5.s[89]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: "body",
          className: tableClass('simple-body'),
          ref: this.bindBody,
          onScroll: this.handleScroll,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 222,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("table", {
          style: {
            width: width
          },
          className: tableClass((cov_265yqg3il5.b[34][0]++, !colgroup) && (cov_265yqg3il5.b[34][1]++, minWidthSup) && (cov_265yqg3il5.b[34][2]++, 'init'), (cov_265yqg3il5.b[35][0]++, bordered) && (cov_265yqg3il5.b[35][1]++, 'table-bordered')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 223,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Colgroup, {
          colgroup: colgroup,
          columns: columns,
          resizable: columnResizable,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 227,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement(Tbody, Object.assign({
          colgroup: colgroup,
          lazy: false,
          index: 0,
          columns: columns,
          onBodyRender: this.handleColgroup,
          resize: resize,
          bordered: bordered,
          columnResizable: columnResizable
        }, others, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 228,
            columnNumber: 11
          }
        }))))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_265yqg3il5.f[18]++;

      var _ref11 = (cov_265yqg3il5.s[90]++, this.props),
          columns = _ref11.columns,
          width = _ref11.width,
          children = _ref11.children,
          hideHeader = _ref11.hideHeader,
          bordered = _ref11.bordered;

      cov_265yqg3il5.s[91]++;

      if ((cov_265yqg3il5.b[37][0]++, !columns) || (cov_265yqg3il5.b[37][1]++, columns.length === 0)) {
        cov_265yqg3il5.b[36][0]++;
        cov_265yqg3il5.s[92]++;
        return (
          /*#__PURE__*/
          React.createElement("table", {
            style: {
              width: width
            },
            className: tableClass((cov_265yqg3il5.b[38][0]++, bordered) && (cov_265yqg3il5.b[38][1]++, 'table-bordered')),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 248,
              columnNumber: 9
            }
          }, children)
        );
      } else {
        cov_265yqg3il5.b[36][1]++;
      }

      cov_265yqg3il5.s[93]++;
      return [hideHeader ? (cov_265yqg3il5.b[39][0]++, null) : (cov_265yqg3il5.b[39][1]++, this.renderHeader()), this.renderBody(), this.renderFooter(), children];
    }
  }]);

  return SimpleTable;
}(PureComponent);

export default SimpleTable;